import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
var NewAccount = function () { return (_jsx(Navigate, { to: "/accounts", replace: true, state: { openNewAccount: true } })); };
export default NewAccount;
